import React from "react";
import { calc } from "../../js/chips-common";
import Lottie from "react-lottie";
import prize1000 from "../assets/1000.json";
import prize2000 from "../assets/2000.json";
import prize4000 from "../assets/4000.json";

export default function PrizeGroups({ prizeGroups, onPrizeGroupClick }) {
  const getLottieJson = (index) => {
    if (index === 0) {
      return prize1000;
    } else if (index === 1) {
      return prize2000;
    } else {
      return prize4000;
    }
  };

  const getStyle = (index) => {
    if (index === 0) {
      return {
        overflow: "hidden",
        display: "flex",
        justifyContent: "justify",
        alignItems: "justify",
        width: calc(115),
      };
    } else if (index === 1) {
      return {
        overflow: "hidden",
        display: "flex",
        justifyContent: "justify",
        alignItems: "justify",
        width: calc(115),
      };
    } else {
      return {
        overflow: "hidden",
        display: "flex",
        justifyContent: "justify",
        alignItems: "justify",
        width: calc(115),
      };
    }
  };

  return (
    <div
      style={{
        padding: `${calc(0)}px ${calc(7)}px ${calc(0)}px ${calc(7)}px`,
        marginTop: calc(-22),
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        position: "relative",
        marginBottom: calc(80),
        zIndex: 1,
      }}
    >
      {prizeGroups.map((prizeGroup, index) => (
        <div
          key={`${prizeGroup.id}-${index}`}
          className="active-large"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            background: "transparent",
            boxSizing: "border-box",
          }}
          onClick={() => onPrizeGroupClick(prizeGroup)}
        >
          <PrizeImage lottie={getLottieJson(index)} style={getStyle(index)} />
        </div>
      ))}
    </div>
  );
}

function PrizeImage({ lottie, style }) {
  return (
    <div style={style}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: lottie,
          rendererSettings: {
            preserveAspectRatio: "xMinYMin slice",
            className: "lottie-svg-class",
            id: "lottie-svg-id",
          },
        }}
        isClickToPauseDisabled={true}
        style={{
          top: calc(0),
          width: calc(style.width),
        }}
      />
    </div>
  );
}
